import type { SongSummary } from '@pipi/shared';
import { ArrowRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { SongCard } from './song-card';

export function SongRail({ title, eyebrow, songs, moreTo }: { title: string; eyebrow?: string; songs: SongSummary[]; moreTo?: string }) {
  const navigate = useNavigate();
  if (!songs.length) return null;
  return (
    <section className="song-rail">
      <header className="section-heading">
        <div>
          {eyebrow && <span>{eyebrow}</span>}
          <h2>{title}</h2>
        </div>
        {moreTo && (
          <button type="button" data-tv-focusable className="text-link" onClick={() => navigate(moreTo)}>
            查看全部 <ArrowRight size={20} />
          </button>
        )}
      </header>
      <div className="song-rail__track">
        {songs.slice(0, 8).map((song, index) => <SongCard key={song.id} song={song} index={index} />)}
      </div>
    </section>
  );
}
